import Layout from '../../../../layout/Layout'
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'
import { Box } from '../../../../components/atoms/AppBox'
import CompanyForm from '../organims/CompanyForm'
import { useNavigate } from 'react-router-dom'
import { AxiosCompanyRepository } from 'company/infrastructure/AxiosCompanyRepository'
import { CreateCompanyUseCase } from 'company/usecases/CreateCompanyUseCase'
import { Snackbar } from '../../../../components/atoms/Snackbar/Snackbar'
import { useRef, useState } from 'react'

interface SnackbarHandle {
    showModal: (value: boolean) => void
}
export default function CreateCompanyPage() {
    const navigate = useNavigate()
    const snackbarRef = useRef<SnackbarHandle>(null)
    const repository = new AxiosCompanyRepository()
    const createCompanyUseCase = new CreateCompanyUseCase(repository)
    const [snackbarMessage, setSnackbarMessage] = useState<{
        title: string
        description: string
        state: 'success' | 'error'
    }>({
        title: 'Éxito',
        description: 'Acción completada',
        state: 'success',
    })

    const handleCompanyCreated = () => {
        setSnackbarMessage({
            title: '¡Éxito!',
            description: 'Empresa creada exitosamente',
            state: 'success',
        })
        navigate('/companies')
    }

    return (
        <Layout>
            <HeaderPageSection title="Registrar empresa" showGoBack={true} />
            <Box>
                <CompanyForm
                    createCompanyUseCase={createCompanyUseCase}
                    onSuccess={handleCompanyCreated}
                />
                <Snackbar
                    ref={snackbarRef}
                    title={snackbarMessage.title}
                    description={snackbarMessage.description}
                    state={snackbarMessage.state}
                    closeAction
                    time={2000}
                />
            </Box>
        </Layout>
    )
}
